import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import ImgMain from "./pages/socialMedia";
import EmailImgMain from "./pages/emailGenerator";
import YoutubeImgMain from "./pages/ytThumbnail";
import FileUploader from "./pages/fileUploader";
import "./styles/App.scss";
import ProtectedRoute from "./routes/protectedRoute";
import { useEffect, useState } from "react";
import Main from "./pages/main";
import { UploadSection } from "./components/file-uploader/uploadSection";
import StatusProvider from "./context/statusProvider";
import ResponseProvider from "./context/responseProvider";
import {
  CONTENT_EDITOR,
  CREDIT_BONUS,
  DIVIDEND_FEED,
  EMAIL_IMAGE_GENERATOR,
  GENERAL,
  IMAGE_GENERATOR,
  LEGAL_DOCUMENTS,
  MERCH,
  MERCH_MANAGER_EDITOR,
  PDF_VIEWER,
  TRADING_HOURS,
  UPLOAD,
  YT_THUMBNAIL_CREATOR,
} from "./routes/routes";
import UploadProvider from "./context/UploadProvider";
import ContentEditor from "./pages/ContentEditor";
import PdfHtmlViewer from "./pages/PdfToHtml";
import CreditBonus from "./pages/creditBonus";
import MerchendiseManager from "./pages/merchManager";
import { VerifiedUsersProvider } from "./context/verifiedUserProvider";
import AllowedUsers from "./routes/allowedUsers";
import Merchendise from "./pages/merchandise";
import { PERMISSIONS } from "./constants/permissions";

function App() {
  const [locationState, setLocationState] = useState("");
  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      const { stateObj } = state;
      if (stateObj) {
        setLocationState(stateObj.id);
      }
    }
  }, [state]);

  return (
    <VerifiedUsersProvider>
      <Routes>
        <Route>
          <Route path="/" element={<Main />} />
          <Route
            path={`/${UPLOAD}`}
            element={
              <ProtectedRoute>
                <StatusProvider>
                  <ResponseProvider>
                    <UploadProvider>
                      <FileUploader />
                    </UploadProvider>
                  </ResponseProvider>
                </StatusProvider>
              </ProtectedRoute>
            }
          >
            <Route path={DIVIDEND_FEED} element={<UploadSection />} />
            <Route path={GENERAL} element={<UploadSection />} />
            <Route path={TRADING_HOURS} element={<UploadSection />} />
            <Route path={LEGAL_DOCUMENTS} element={<UploadSection />} />
          </Route>

          {/* testing - comment before merging to main */}
          {/* <Route
            path="/upload/test"
            element={
              <ProtectedRoute>
                  <FileUploader />
              </ProtectedRoute>
            }
          /> */}
          {/* End of testing route */}
          <Route
            path={`${CREDIT_BONUS}`}
            element={
              <ProtectedRoute>
                <StatusProvider>
                  <ResponseProvider>
                    <AllowedUsers
                      permission={[PERMISSIONS.CB]}
                      fallback={true}
                      isRoute={true}
                    >
                      <CreditBonus locationState={locationState} />
                    </AllowedUsers>
                  </ResponseProvider>
                </StatusProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path={`${MERCH}`}
            element={
              <ProtectedRoute>
                <StatusProvider>
                  <ResponseProvider>
                    <AllowedUsers
                      permission={[
                        PERMISSIONS.MERCH_VIEWER,
                        PERMISSIONS.MERCH_MANAGER,
                      ]}
                      fallback={true}
                      isRoute={true}
                    >
                      <Merchendise locationState={locationState} />
                    </AllowedUsers>
                  </ResponseProvider>
                </StatusProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path={`${MERCH_MANAGER_EDITOR}/:id?`}
            element={
              <ProtectedRoute>
                <StatusProvider>
                  <ResponseProvider>
                    <AllowedUsers
                      permission={[PERMISSIONS.MERCH_MANAGER]}
                      fallback={true}
                      isRoute={true}
                    >
                      <MerchendiseManager locationState={locationState} />
                    </AllowedUsers>
                  </ResponseProvider>
                </StatusProvider>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path={`${TRUSTPILOT_INVS}`}
            element={
              <ProtectedRoute>
                <StatusProvider>
                  <Dashboard locationState={locationState} />
                </StatusProvider>
              </ProtectedRoute>
            }
          /> */}
          <Route
            path={`${CONTENT_EDITOR}`}
            element={
              <ProtectedRoute>
                <ContentEditor locationState={locationState} />
              </ProtectedRoute>
            }
          />
          <Route
            path={PDF_VIEWER}
            element={
              <>
                <PdfHtmlViewer locationState={locationState} />
              </>
            }
          />
          <Route
            path={`/${IMAGE_GENERATOR}/:id`}
            element={
              <ProtectedRoute>
                <ImgMain locationState={locationState} />
              </ProtectedRoute>
            }
          />
          <Route
            path={`/${EMAIL_IMAGE_GENERATOR}/*`}
            element={
              <ProtectedRoute>
                <EmailImgMain />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={`/${YT_THUMBNAIL_CREATOR}/*`}
          element={
            <ProtectedRoute>
              <YoutubeImgMain />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </VerifiedUsersProvider>
  );
}

export default App;
